import { render } from "./CreateArticleView.vue?vue&type=template&id=e99ba4d8"
import script from "./CreateArticleView.vue?vue&type=script&lang=js"
export * from "./CreateArticleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__